import {
  RESET_ORDERS_LIST,
  ORDERS_LIST_NOT_FOUND,
  ORDERS_LIST_FAILED,
  ORDERS_LIST_INVALID_REQUEST,
  ORDERS_LIST_SUCCESS,
  LOADING_ORDERS_LIST,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  orders: [],
  status: [
    "Placed",
    "Under Process",
    "Processed",
    "Dispatched",
    "Delivered",
    "Cancelled",
  ],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ORDERS_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case ORDERS_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };

    case ORDERS_LIST_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case ORDERS_LIST_SUCCESS: {
      const { status } = state;
      const { ordersList } = action.payload;
      const orders = JSON.parse(ordersList || "[]");
      console.log(orders);
      const newOrders = orders.map((o) => {
        if (!status[o.statusId]) return o;

        return {
          ...o,
          nextStatus: status[o.statusId],
        };
      });
      console.log(newOrders);
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        orders: newOrders,
      };
    }

    case ORDERS_LIST_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_ORDERS_LIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
